<!-- 地区选择组件（省市区） -->
<template>
    <div>
        <Cascader
            v-model="curCity"
            class="city-option"
            :data="cityOptions"
            :class="extraClass"
            clearable
            :disabled="disabled"
            :placeholder="placeholder"
            :render-format="formatCity"
            @on-change="cityChange"
        />
    </div>
</template>

<script>
/**
 * @file index.vue
 * @desc 地区选择组件
 * @author dingzhenyue
 */
import {cloneDeep} from 'lodash';

export default {
    name: 'citySelect',
    data() {
        return {
            // 全国城市信息
            cityOptions: [],
            // 当前选中信息
            curCity: this.city
        };
    },
    props: {
        // 默认选中地区
        city: {
            'type': Array,
            'default': () => []
        },
        // 1:只展示省 2:展示省+市 3:展示省+市+区
        type: {
            'type': String,
            'default': '3'
        },
        // 传入的样式类
        extraClass: {
            'type': String,
            'default': ''
        },
        // 是否禁选
        disabled: {
            'type': Boolean,
            'default': false
        },
        placeholder: {
            'type': String,
            'default': '请选择'
        },
        // 格式化选择后展示的数据的函数
        formatCity: {
            'type': Function,
            'default': data => {
                return data.join('/');
            }
        }
    },
    watch: {
        city: {
            handler(newVal, oldVal) {
                // 数组长度不一致，则更新数据
                if (newVal.length !== this.curCity.length) {
                    this.curCity = newVal;
                    return;
                }
                let isSame = true;
                this.curCity.forEach((item, index) => {
                    if (item !== newVal[index]) {
                        isSame = false;
                    }
                });
                // 数组长度一致，内容不一致，则更新数据
                !isSame && (this.curCity = newVal);
            },
            deep: true
        }
    },
    created() {
        this.getCity();
    },
    methods: {
        /**
         * 获取全国城市数据
         */

        getCity() {
            this.$http.get('/bp/api/city/cityAll', {
            }).then(res => {
                if (!res || +res.code !== 0) {
                    return;
                }
                res = res?.data;
                if (!res) {
                    return;
                }
                this.handleCityData(res);
            }).catch(err => this.$normalizeResponseError(err));
        },

        /**
         * 城市选择改变
         * @param {Array} value 即已选值,如[110000, 110100]
         * @param {Array} selectedData 已选项的具体数据,如[{label: "天津市", value: 120000}]
         */

        cityChange(value, selectedData) {
            this.$emit('cityChange', {value, selectedData});
        },

        /**
         * 处理省市区数据
         * @param {Array} data 省市区数据
         * @return {Array} 处理后的省市区数据
         */

        handleCityData(data) {
            data = cloneDeep(data);
            // 省市区
            if (this.type === '3') {
                this.cityOptions = data;
                return;
            }
            for (let i = 0; i < data.length; i++) {
                // 只展示省
                if (this.type === '1') {
                    delete data[i].children;
                    continue;
                }
                // 展示省市
                for (let j = 0; j < data[i].children.length; j++) {
                    delete data[i].children[j].children;
                }
            }
            this.cityOptions = data;
        }
    }
};
</script>

<style lang='less' scoped>
    .city-option {

        /deep/.ivu-input-wrapper {
            border: 1px solid #E9ECF3;
            border-radius: 8px;

           .ivu-input {
                height: 40px;
                padding: 0 30px 0 12px;
                border: none;
                border-radius: 8px;
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
            }

            &:hover,
            &:focus {
                border: 1px solid #3855D5;
            }
        }

        /deep/.ivu-cascader-visible {

            .ivu-input-wrapper {
                border: 1px solid #3855D5;
            }
        }
    }

    /deep/.ivu-cascader .ivu-select-dropdown {
        width: max-content;
    }
</style>
